import { IParams, tryFetch } from "helpers/FetchAPI";

export const getStoreCount = async (token: string) => {
  const params: IParams = {
    url: "/g/ers/stores/count",
    method: "GET",
    token,
  };
  return await tryFetch(params);
};

export const getProductCount = async (token: string) => {
  const params: IParams = {
    url: "/g/pim/products/count",
    method: "GET",
    token,
  };
  return await tryFetch(params);
};

export const getStoreProductCount = async (token: string) => {
  const params: IParams = {
    url: "/g/ers/storeproduct/count",
    method: "GET",
    token,
  };
  return await tryFetch(params);
};

export const getActiveProductCount = async (token: string) => {
  const params: IParams = {
    url: "/g/ers/product-activated/count",
    method: "GET",
    token,
  };
  return await tryFetch(params);
};


export const getActiveStoreCount = async (token: string) => {
  const params: IParams = {
    url: "/g/ers/store-activated/count",
    method: "GET",
    token,
  };
  return await tryFetch(params);
};

export const getDashboardOrders = async (token: string) => {
  const params: IParams = {
    url: "/g/ers/dashboard/orders",
    method: "GET",
    token,
  };
  return await tryFetch(params);
};

export const getStore = async (token: string, query: string) => {
  const params: IParams = {
    url: "/g/ers/stores",
    method: "GET",
    token,
    query,
  };
  return await tryFetch(params);
};
